import raystaskapi from '@/api/raystaskapi';
import Utils from '@/utils/utils';

const SESSION_STORAGE_KEY = 'RAYS7_CREATIVE_TASK_SESSION_DATA';

// 任务CODE
export const TRACE_TYPE_CODES = {
  AI_DIGITIZATION_ENGLISH: 'AI_DIGITIZATION_ENGLISH', // AI数字创作编辑-制作英语听力配音
  AI_DIGITIZATION_BOOK: 'AI_DIGITIZATION_BOOK', // AI数字创作编辑-制作多角色配音
  EXPERIENCE_AUDIO_BOOK: 'EXPERIENCE_AUDIO_BOOK' // AI数字创作编辑 - 制作浓缩书配音
};

export function creativeExperienceAi(traceType, values = {}) {
  const taskData = JSON.parse(window.sessionStorage.getItem(SESSION_STORAGE_KEY));
  if(Utils.isNotEmpty(taskData) && taskData?.traceType === traceType) {
    if(taskData?.recordId) {
      const { resourceInfo } = Object.assign({}, values);
      raystaskapi.submitAigcTaskResult({
        recordId: taskData?.recordId,
        taskType: 'TraceExperienceAi',
        resourceInfo: Utils.isNotEmpty(resourceInfo) ? JSON.stringify(resourceInfo) : ''
      }).then(() => {
        removeStorage();
      });
    } else if(taskData?.weekTaskRecordId) {
      raystaskapi.submitWeekTaskResult({
        weekTaskRecordId: taskData?.weekTaskRecordId,
        taskType: 'TraceExperienceAi'
      }).then(() => {
        removeStorage();
      });
    }
  }
}

const TYPES = {
  READY: 'AI_STUDIO_READY',
  SEND: 'RAYS7_CREATIVE_TASK_SEND',
  RESPONSE: 'RAYS7_CREATIVE_TASK_RESPONSE'
};

// 监听创作任务跳过来消息
export function addEventListenerCreativeMessage() {
  if(window.opener) {
    window.opener.postMessage({ type: TYPES.READY }, '*');
  }

  window.addEventListener('message', event => {
    if(typeof event.data !== 'object') return;
    const { type, data, messageId } = event.data;
    if(type === TYPES.SEND) {
      window.sessionStorage.setItem(SESSION_STORAGE_KEY, JSON.stringify(data));
      event.source.postMessage({
        type: TYPES.RESPONSE,
        messageId: messageId
      }, event.origin);
    }
    // 收到子窗口报告 READY，在此项目中可能不需要，因为这里已经是末端了
    if(type === TYPES.READY) {
      const taskDataStr = window.sessionStorage.getItem(SESSION_STORAGE_KEY);
      if(taskDataStr) {
        event.source.postMessage({
          type: TYPES.SEND,
          data: JSON.parse(taskDataStr)
        }, event.origin);
      }
    }
  });
}

const removeStorage = () => {
  window.sessionStorage.removeItem(SESSION_STORAGE_KEY);
};
